<template>
  <div class="main_resource">
    <b-overlay
      :show="isLoading"
      :variant="'white'"
      :opacity="0.7"
      :blur="'2px'"
      rounded="sm"
      no-wrap
      style="z-index: 1050;"
    />
    <div v-if="mainResource && (mainResource.isProcessingPending() || mainResource.isProcessingFailed() )">
      <ResourceProcessingAlert
        v-on="$listeners"
        :resource="mainResource"
        :process="mainResource._processing[0]"
        :resource-id="mainResource.id"
        :task-id="mainResource._processing[0].task_id"
      />
    </div>
    <div v-if="mainResource && mainResource.id">
      <ResourceEditor
        :key="`main-resource-editor-${mainResource.id}`"
        :resource="mainResource"
        :dataset="currentDataset"
        :disabled="mainResource.isProcessingPending()"
        v-on="$listeners"
        
        @delete="isDeleteResourceModalOpen = true"
      /><!--@get="getMainResource"-->
      <div
        :class="{
          disabled: mainResource.isProcessingPending()
        }"
        class="resource__delete"
      >
        <div />
        <b-button
          variant="danger"
          @click="isDeleteResourceModalOpen = true"
        >
          {{ $t(`buttons.delete`) }}
        </b-button>
      </div>
    </div>
    <div
      v-else-if="mainResource && !mainResource.id"
    >
      <p class="infos">
        {{ $t('datasetDetail.mainResource.empty') }}
      </p>
      <ResourceCreator
        :resource="mainResource"
        :required="false"
        v-on="$listeners"
      />
    </div>
    <DeleteResourceModal
      :open="isDeleteResourceModalOpen"
      :resource="mainResource"
      @hide="isDeleteResourceModalOpen = false"
      @delete="deleteResource"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import DeleteResourceModal from '@/components/Resource/modals/DeleteResourceModal.vue';
import ResourceCreator from '@/components/Resource/ResourceCreator.vue';
import ResourceEditor from '@/components/Resource/ResourceEditor.vue';
import ResourceProcessingAlert from '@/components/Resource/ResourceProcessingAlert.vue';

export default {
  name: 'MainResource',

  components: {
    DeleteResourceModal,
    ResourceCreator,
    ResourceEditor,
    ResourceProcessingAlert
  },

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    mainResource: {
      type: Object,
      default: null
    }
  },
  
  data() {
    return {
      isLoading: false,
      isDeleteResourceModalOpen: false
    };
  },

  computed: {
    ...mapState('datasets', [
      'currentDataset',
    ]),
  },

  watch: {
    loading(newValue) {
      this.isLoading = newValue;
    },
  },


  mounted() {
    // Watch modal closing event
    this.$root.$on('bv::modal::hide', () => {
      this.isDeleteResourceModalOpen = false;
    });
  },

  methods: {
    ...mapActions('resources', [
      'DELETE_RESOURCE'
    ]),


    deleteResource() {
      this.isLoading = true;

      this.DELETE_RESOURCE(this.mainResource)
        .then(() => {
          this.isLoading = false;
          this.$emit('delete',this.mainResource);
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
      
        
    },
    
  }
};
</script>

<style lang="less" scoped>
.alert-resource {
  margin: 1rem -1px 1rem -1px !important;
}
</style>
